import { motion } from "framer-motion";
import { useEffect } from "react";
import { useSearchParams, Link } from "react-router-dom";
import { CheckCircle } from "lucide-react";

const WA_LINK = "https://wa.me/393296281756?text=Ciao%20Danielealoisi%2C%20vorrei%20un%20preventivo%2Fsopralluogo%20per%20infissi%20o%20lavorazioni%20in%20ferro.%20Zona%3A%20_____%20.%20Posso%20inviare%20alcune%20foto.";

const ThankYou = () => {
  const [searchParams] = useSearchParams();
  const name = searchParams.get("name") || "";
  const service = searchParams.get("service") || "";

  useEffect(() => {
    // GA4 / GTM conversion event
    if (typeof window !== "undefined" && (window as any).gtag) {
      (window as any).gtag("event", "generate_lead", {
        event_category: "form",
        event_label: service || "preventivo",
        value: 1,
      });
    }
    // Facebook Pixel
    if (typeof window !== "undefined" && (window as any).fbq) {
      (window as any).fbq("track", "Lead", {
        content_name: service || "preventivo",
      });
    }
  }, [service]);

  return (
    <main className="min-h-screen bg-background flex items-center justify-center px-6 py-24">
      <motion.div
        initial={{ opacity: 0, y: 40 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8 }}
        className="max-w-xl w-full text-center"
      >
        <motion.div
          initial={{ scale: 0 }}
          animate={{ scale: 1 }}
          transition={{ type: "spring", stiffness: 200, delay: 0.3 }}
          className="inline-flex items-center justify-center w-20 h-20 rounded-full bg-accent/20 mb-8"
        >
          <CheckCircle className="w-10 h-10 text-accent" />
        </motion.div>

        <h1 className="font-heading text-3xl md:text-5xl font-bold text-foreground leading-tight">
          {name ? `Grazie ${name}!` : "Grazie!"}
        </h1>

        <p className="mt-6 text-muted-foreground font-body text-base md:text-lg leading-relaxed max-w-md mx-auto">
          Abbiamo ricevuto la tua richiesta{service ? ` per "${service}"` : ""}. Ti ricontatteremo entro poche ore per fissare un sopralluogo o inviarti un preventivo.
        </p>

        <div className="mt-8 p-6 border border-foreground/10 rounded-sm">
          <p className="text-sm text-foreground/70 font-body">
            <strong className="text-foreground">Velocizza i tempi:</strong> invia 2–3 foto su WhatsApp con le misure approssimative. Così prepariamo subito una valutazione.
          </p>
        </div>

        <div className="mt-10 flex flex-col sm:flex-row items-center justify-center gap-4">
          <a
            href={WA_LINK}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center justify-center gap-2 px-8 py-3 text-sm tracking-widest uppercase font-body bg-[#25D366] text-white rounded-sm hover:-translate-y-0.5 active:scale-[0.98] transition-all duration-300 w-full sm:w-auto"
          >
            Invia foto su WhatsApp
          </a>
          <Link
            to="/"
            className="cta-button hover:-translate-y-0.5 active:scale-[0.98] transition-all duration-300 w-full sm:w-auto text-center"
          >
            Torna alla home
          </Link>
        </div>

        <p className="mt-12 text-xs text-muted-foreground/50 font-body">
          Oppure chiamaci: <a href="tel:+393296281756" className="underline underline-offset-2 hover:text-foreground transition-colors">329 628 1756</a>
        </p>
      </motion.div>
    </main>
  );
};

export default ThankYou;
